import css from 'styled-jsx/css';
import { colors, icons } from '../../../config/styles';
import { svgToDataUri } from '../../../utils/styles/svgMixins';

export const DeliveryErrorStyles = css`
  .delivery-errors-container {
    padding: 16px;
    margin: 8px 0;
    border-bottom: 1px solid #f1f1f1;
  }

  .delivery-error-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .title-container {
    display: flex;
    justify-content: flex-start;
    gap: 8px;
  }

  .error-icon {
    width: 16px;
    height: 16px;
    background-image: url('${svgToDataUri(icons.blocked)}');
    background-size: contain;
    background-repeat: no-repeat;
  }
  .error-content {
    flex: 1;
  }

  .error-title {
    margin: 0 0 4px 0;
    font-size: 14px;
    font-weight: 600;
    color: #bc001c;
    line-height: 1.3;
  }

  .error-message {
    margin: 0 0 4px 0;
    font-size: 13px;
    color: ${colors.black.shade10};
    line-height: 1.4;
  }

  /* Responsive */
  @media (max-width: 768px) {
    .delivery-errors-container {
      padding: 12px;
      margin: 12px 0;
    }

    .error-title {
      font-size: 13px;
    }

    .error-message {
      font-size: 12px;
    }
  }
`;
